/**
 * Created by mauget on 9/20/16.
 */

import contentTemplate from 'designer/report-menu.ejs';
import LayoutMenuView from 'LayoutMenuView.js';
import undoService      from 'UndoService.js';
import util              from 'util/Util';
import formService from 'FormService';


//=================================================================================================
//
// An instance forms BackBone view of the menubar used atop the report panel.
// It specializes the menu template.
//
// Lou Mauget, September 20, 2016
//
//=================================================================================================
class ReportMenuView extends LayoutMenuView {

    initialize( opts ) {
        super.initialize( opts );
        this.template = contentTemplate;

        // Replace form save event handlers with report save handlers.
        this.events = Object.assign( this.events, {
            'click #designerSave'           : 'saveReport',
            'click #designerSaveNewVersion' : 'saveReportNewVersion',
            'click #designerSaveNewForm'    : 'saveReportAsNew',
            'click #designerPublish'        : 'publish',
            'click #designerPreview'        : 'preview',
            'click #designerDebug'        : 'debug',
            'click #pf-close-main-view':'closeForm'
        });

        return this;
    }

    closeForm(ev){
        if (undoService.hasChanges()) { 
            ev.preventDefault();
            ev.returnValue = false; 
            util.removeIfRemainingHelpCenter();                       
            formService.confirmSaveOnClose(); 
        }
        else {
            ev.preventDefault();
            ev.returnValue = false;              
            util.removeIfRemainingHelpCenter();    
            Backbone.history.loadUrl('close');
        }
    }




}

export default ReportMenuView;
